module.exports = __webpack_public_path__ + "static/media/sansiro-tabatinga-embreve-02.02f5ae24.jpg";